import Section from '../common/Section';

const BioSection = ({ data, onChange }) => (
  <Section eyebrow="Step 3" title="Player bio / description">
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Short Bio / Introduction</label>
        <textarea
          name="intro"
          className="form-control"
          rows="3"
          value={data.intro}
          onChange={(e) => onChange('bio', 'intro', e.target.value)}
          placeholder="Tell us about your playing style, level and ambitions"
        />
      </div>
      <div className="col-md-6">
        <label className="form-label">Playing Experience (years)</label>
        <input
          type="number"
          min="0"
          name="experience"
          className="form-control"
          value={data.experience}
          onChange={(e) => onChange('bio', 'experience', e.target.value)}
          placeholder="5"
        />
      </div>
      <div className="col-md-6">
        <label className="form-label">Strengths (batting, bowling, fielding)</label>
        <textarea
          name="strengths"
          className="form-control"
          rows="3"
          value={data.strengths}
          onChange={(e) => onChange('bio', 'strengths', e.target.value)}
          placeholder="Powerplay hitting, death bowling, safe hands at point"
        />
      </div>
      <div className="col-md-6">
        <label className="form-label">Nickname (optional)</label>
        <input
          type="text"
          name="nickname"
          className="form-control"
          value={data.nickname}
          onChange={(e) => onChange('bio', 'nickname', e.target.value)}
          placeholder="Hitman"
        />
      </div>
    </div>
  </Section>
);

export default BioSection;
